import { lazy } from 'react';

export const Clients = lazy(() =>
  import('./clients').then((module) => ({ default: module.Clients })),
);

export const ClientForm = lazy(() =>
  import('./clients').then((module) => ({ default: module.ClientForm })),
);

export const ClientShow = lazy(() =>
  import('./clients').then((module) => ({ default: module.ClientShow })),
);

export const NewClients = lazy(() =>
  import('./new_clients').then((module) => ({ default: module.NewClients })),
);

export const NewClientForm = lazy(() =>
  import('./new_clients').then((module) => ({ default: module.NewClientForm })),
);

export const Companies = lazy(() =>
  import('./companies/list').then((module) => ({ default: module.Companies })),
);

export const CompanyForm = lazy(() =>
  import('./companies').then((module) => ({
    default: module.CompanyForm,
  })),
);

export const CompanyDetails = lazy(() =>
  import('./companies').then((module) => ({
    default: module.CompanyDetails,
  })),
);

export const CompanyCustomFields = lazy(() =>
  import('./settings/custom_fields').then((module) => ({
    default: module.CompanyCustomFields,
  })),
);

export const CompanyCustomFieldForm = lazy(() =>
  import('./settings/custom_fields').then((module) => ({
    default: module.CompanyCustomFieldForm,
  })),
);

export const Certificates = lazy(() =>
  import('./certificates').then((module) => ({ default: module.Certificates })),
);

export const CertificateForm = lazy(() =>
  import('./certificates').then((module) => ({
    default: module.CertificateForm,
  })),
);

export const Promotions = lazy(() =>
  import('./promotions').then((module) => ({ default: module.Promotions })),
);

export const PromotionForm = lazy(() =>
  import('./promotions').then((module) => ({
    default: module.PromotionForm,
  })),
);

export const Services = lazy(() =>
  import('./services').then((module) => ({ default: module.Services })),
);

export const ServiceForm = lazy(() =>
  import('./services').then((module) => ({ default: module.ServiceForm })),
);

export const ServiceCategories = lazy(() =>
  import('./service_categories').then((module) => ({
    default: module.ServiceCategories,
  })),
);

export const ServiceCategoryForm = lazy(() =>
  import('./service_categories').then((module) => ({
    default: module.ServiceCategoryForm,
  })),
);

export const CatalogServices = lazy(() =>
  import('./settings/catalog/services').then((module) => ({
    default: module.CatalogServices,
  })),
);

export const CatalogCards = lazy(() =>
  import('./settings/catalog/cards').then((module) => ({
    default: module.CatalogCards,
  })),
);

export const CatalogCertificates = lazy(() =>
  import('./settings/catalog/certificates').then((module) => ({
    default: module.CatalogCertificates,
  })),
);

export const CatalogCertificateForm = lazy(() =>
  import('./settings/catalog/certificates').then((module) => ({
    default: module.CatalogCertificateForm,
  })),
);

export const OnlineServices = lazy(() =>
  import('./online_services').then((module) => ({
    default: module.OnlineServices,
  })),
);

export const OnlineServiceForm = lazy(() =>
  import('./online_services').then((module) => ({
    default: module.OnlineServiceForm,
  })),
);

export const OrdersInfo = lazy(() =>
  import('./orders_info').then((module) => ({ default: module.OrdersInfo })),
);

export const OrderPaymentExports = lazy(() =>
  import('./order_payment_exports').then((module) => ({
    default: module.OrderPaymentExports,
  })),
);

export const Trainers = lazy(() =>
  import('./trainers').then((module) => ({ default: module.Trainers })),
);

export const TrainerForm = lazy(() =>
  import('./trainers').then((module) => ({ default: module.TrainerForm })),
);

export const Locations = lazy(() =>
  import('./locations').then((module) => ({ default: module.Locations })),
);

export const LocationForm = lazy(() =>
  import('./locations').then((module) => ({ default: module.LocationForm })),
);

export const ScanningDevices = lazy(() =>
  import('./integrations/scanning_devices').then((module) => ({
    default: module.ScanningDevices,
  })),
);

export const ScanningDeviceForm = lazy(() =>
  import('./integrations/scanning_devices').then((module) => ({
    default: module.ScanningDeviceForm,
  })),
);

export const StaffAccessPasses = lazy(() =>
  import('./staff/access_passes').then((module) => ({
    default: module.StaffAccessPasses,
  })),
);

export const Fiscalization = lazy(() =>
  import('./fiscalization').then((module) => ({
    default: module.Fiscalization,
  })),
);

export const FiscalizationCashiers = lazy(() =>
  import('./integrations/fiscalization').then((module) => ({
    default: module.FiscalizationCashiers,
  })),
);

export const FiscalizationCashierForm = lazy(() =>
  import('./integrations/fiscalization').then((module) => ({
    default: module.FiscalizationCashierForm,
  })),
);

export const FiscalizationReport = lazy(() =>
  import('./reports/fiscalization').then((module) => ({
    default: module.FiscalizationReport,
  })),
);

export const SpecialistPayoutsTmpReport = lazy(() =>
  import('./reports/specialist_payouts_tmp').then((module) => ({
    default: module.SpecialistPayoutsTmpReport,
  })),
);

export const SpecialistPayoutTmpExports = lazy(() =>
  import('./reports/specialist_payout_tmp_exports').then((module) => ({
    default: module.SpecialistPayoutTmpExports,
  })),
);

export const FiscalRegistrars = lazy(() =>
  import('./fiscal_registrars').then((module) => ({
    default: module.FiscalRegistrars,
  })),
);

export const FiscalOnlineRegistrars = lazy(() =>
  import('./income_payment_settings/fiscal_online_registrars').then(
    (module) => ({
      default: module.FiscalOnlineRegistrars,
    }),
  ),
);

export const FiscalOnlineRegistrarForm = lazy(() =>
  import('./income_payment_settings/fiscal_online_registrars').then(
    (module) => ({
      default: module.FiscalOnlineRegistrarForm,
    }),
  ),
);

export const FiscalOnlineRegistrar = lazy(() =>
  import('./income_payment_settings/fiscal_online_registrars').then(
    (module) => ({
      default: module.FiscalOnlineRegistrarShow,
    }),
  ),
);

export const OnlinePaymentKeys = lazy(() =>
  import('./integrations/acquiring/online_payment_keys').then((module) => ({
    default: module.OnlinePaymentKeys,
  })),
);

export const OnlinePaymentKeyForm = lazy(() =>
  import('./integrations/acquiring/online_payment_keys').then((module) => ({
    default: module.OnlinePaymentKeyForm,
  })),
);

export const PaymentCards = lazy(() =>
  import('./income_payment_settings/payment_cards').then((module) => ({
    default: module.PaymentCards,
  })),
);

export const PaymentCardForm = lazy(() =>
  import('./income_payment_settings/payment_cards').then((module) => ({
    default: module.PaymentCardForm,
  })),
);

export const Cashiers = lazy(() =>
  import('./income_payment_settings/cashiers').then((module) => ({
    default: module.Cashiers,
  })),
);

export const CashierForm = lazy(() =>
  import('./income_payment_settings/cashiers').then((module) => ({
    default: module.CashierForm,
  })),
);

export const CashierTerminals = lazy(() =>
  import('./integrations/terminals/cashier_terminals').then((module) => ({
    default: module.CashierTerminals,
  })),
);

export const CashierTerminalForm = lazy(() =>
  import('./integrations/terminals/cashier_terminals').then((module) => ({
    default: module.CashierTerminalForm,
  })),
);

export const PosTerminals = lazy(() =>
  import('./integrations/terminals/pos_terminals').then((module) => ({
    default: module.PosTerminals,
  })),
);

export const PosTerminalForm = lazy(() =>
  import('./integrations/terminals/pos_terminals').then((module) => ({
    default: module.PosTerminalForm,
  })),
);

export const PayBridges = lazy(() =>
  import('./integrations/terminals/pay_bridges').then((module) => ({
    default: module.PayBridges,
  })),
);

export const PayBridgeForm = lazy(() =>
  import('./integrations/terminals/pay_bridges').then((module) => ({
    default: module.PayBridgeForm,
  })),
);

export const AdminOnlineCertificates = lazy(() =>
  import('./online_certificates').then((module) => ({
    default: module.AdminOnlineCertificates,
  })),
);

export const AdminOnlineCertificateForm = lazy(() =>
  import('./online_certificates').then((module) => ({
    default: module.AdminOnlineCertificateForm,
  })),
);

export const ServiceUsageHistoryAnalytics = lazy(() =>
  import('./service_usage_history_analytics').then((module) => ({
    default: module.ServiceUsageHistoryAnalytics,
  })),
);

export const ServiceUsageHistoryExports = lazy(() =>
  import('./service_usage_history_exports').then((module) => ({
    default: module.ServiceUsageHistoryExports,
  })),
);

export const UserActivityLogs = lazy(() =>
  import('./staff/user_activity_logs').then((module) => ({
    default: module.UserActivityLogs,
  })),
);

export const BookingCalendar = lazy(() =>
  import('./booking/calendar').then((module) => ({
    default: module.BookingCalendar,
  })),
);

export const Calendar = lazy(() =>
  import('./calendar').then((module) => ({
    default: module.Calendar,
  })),
);

export const Reservations = lazy(() =>
  import('./reservations').then((module) => ({
    default: module.Reservations,
  })),
);

export const CompanyEvents = lazy(() =>
  import('./company_events').then((module) => ({
    default: module.CompanyEvents,
  })),
);

export const CompanyEventForm = lazy(() =>
  import('./company_events').then((module) => ({
    default: module.CompanyEventForm,
  })),
);

export const GroupSchedules = lazy(() =>
  import('./group_schedules').then((module) => ({
    default: module.GroupSchedules,
  })),
);

export const BookingEvent = lazy(() =>
  import('./booking/booking_event').then((module) => ({
    default: module.BookingEvent,
  })),
);

export const AllBookings = lazy(() =>
  import('./booking/all_bookings').then((module) => ({
    default: module.AllBookings,
  })),
);

export const BookingServices = lazy(() =>
  import('./booking/booking_services').then((module) => ({
    default: module.BookingServices,
  })),
);

export const BookingServiceForm = lazy(() =>
  import('./booking/booking_services').then((module) => ({
    default: module.BookingServiceForm,
  })),
);

export const BookingProviders = lazy(() =>
  import('./booking/booking_providers').then((module) => ({
    default: module.BookingProviders,
  })),
);

export const BookingProviderForm = lazy(() =>
  import('./booking/booking_providers').then((module) => ({
    default: module.BookingProviderForm,
  })),
);

export const BookingRecurringEvents = lazy(() =>
  import('./booking/booking_recurring_events').then((module) => ({
    default: module.BookingRecurringEvents,
  })),
);

export const BookingRecurringEventForm = lazy(() =>
  import('./booking/booking_recurring_events').then((module) => ({
    default: module.BookingRecurringEventForm,
  })),
);

export const BookingSettings = lazy(() =>
  import('./booking/booking_settings').then((module) => ({
    default: module.BookingSettings,
  })),
);

export const BookingSettingsForm = lazy(() =>
  import('./booking/booking_settings').then((module) => ({
    default: module.BookingSettingsForm,
  })),
);

export const BookingEmailTemplates = lazy(() =>
  import('./booking/email_templates').then((module) => ({
    default: module.BookingEmailTemplates,
  })),
);

export const BookingEmailTemplateForm = lazy(() =>
  import('./booking/email_templates').then((module) => ({
    default: module.BookingEmailTemplateForm,
  })),
);

export const BookingProviderWorkTimeShow = lazy(() =>
  import('./booking/provider_work_time').then((module) => ({
    default: module.BookingProviderWorkTime,
  })),
);

export const BookingsByPaymentDates = lazy(() =>
  import('./booking_analytics/booking_by_payment_dates').then((module) => ({
    default: module.BookingsByPaymentDates,
  })),
);

export const BookingsByBookingDates = lazy(() =>
  import('./booking_analytics/booking_by_booking_dates').then((module) => ({
    default: module.BookingsByBookingDates,
  })),
);

export const IncomeStatistics = lazy(() =>
  import('./analytics/income').then((module) => ({
    default: module.IncomeStatistics,
  })),
);

export const GeneralStatistics = lazy(() =>
  import('./analytics/general_statistics').then((module) => ({
    default: module.GeneralStatistics,
  })),
);

export const ActivePurchasedServices = lazy(() =>
  import('./analytics/active_purchased_services/show').then((module) => ({
    default: module.ActivePurchasedServices,
  })),
);

export const ActivePurсhasedServicesByService = lazy(() =>
  import('./analytics/active_purchased_services_by_service').then((module) => ({
    default: module.ActivePurсhasedServicesByService,
  })),
);

export const ReturnedClientsAnalytics = lazy(() =>
  import('./analytics/returned_clients_analytics').then((module) => ({
    default: module.ReturnedClientsAnalytics,
  })),
);

export const MonthlyIncome = lazy(() =>
  import('./analytics/monthly_income').then((module) => ({
    default: module.MonthlyIncome,
  })),
);

export const SubscriptionsStatistics = lazy(() =>
  import('./analytics/subscriptions_statistics').then((module) => ({
    default: module.SubscriptionsStatistics,
  })),
);

export const ServicesRating = lazy(() =>
  import('./analytics/services_rating').then((module) => ({
    default: module.ServicesRating,
  })),
);

export const AverageServiceVisits = lazy(() =>
  import('./analytics/average_service_visits').then((module) => ({
    default: module.AverageServiceVisits,
  })),
);

export const ExpiringPurchasedServices = lazy(() =>
  import('./analytics/expiring_purchased_services').then((module) => ({
    default: module.ExpiringPurchasedServices,
  })),
);

export const SystemOwners = lazy(() =>
  import('./system_owners').then((module) => ({
    default: module.SystemOwners,
  })),
);

export const Staff = lazy(() =>
  import('./staff').then((m) => ({ default: m.Staff })),
);

export const BookingForm = lazy(() =>
  import('./settings/booking').then((module) => ({
    default: module.BookingForm,
  })),
);

export const BookingEmailTemplateSettings = lazy(() =>
  import('./settings/booking/email_templates').then((module) => ({
    default: module.BookingEmailTemplateSettings,
  })),
);

export const LegalEntities = lazy(() =>
  import('./settings/legal_entities').then((module) => ({
    default: module.LegalEntities,
  })),
);

export const LegalEntityForm = lazy(() =>
  import('./settings/legal_entities').then((module) => ({
    default: module.LegalEntityForm,
  })),
);

export const BusinessDirections = lazy(() =>
  import('./settings/business_directions').then((module) => ({
    default: module.BusinessDirections,
  })),
);

export const BusinessDirectionForm = lazy(() =>
  import('./settings/business_directions').then((module) => ({
    default: module.BusinessDirectionForm,
  })),
);

export const CashRegisters = lazy(() =>
  import('./settings/cash_registers').then((module) => ({
    default: module.CashRegisters,
  })),
);

export const CashRegisterForm = lazy(() =>
  import('./settings/cash_registers').then((module) => ({
    default: module.CashRegisterForm,
  })),
);

export const TransactionCategories = lazy(() =>
  import('./settings/transaction_categories').then((module) => ({
    default: module.TransactionCategories,
  })),
);

export const TransactionCategoryForm = lazy(() =>
  import('./settings/transaction_categories').then((module) => ({
    default: module.TransactionCategoryForm,
  })),
);

export const DiscountReasons = lazy(() =>
  import('./settings/discount_reasons').then((module) => ({
    default: module.DiscountReasons,
  })),
);

export const DiscountReasonForm = lazy(() =>
  import('./settings/discount_reasons').then((module) => ({
    default: module.DiscountReasonForm,
  })),
);

export const RefundReasons = lazy(() =>
  import('./settings/refund_reasons').then((module) => ({
    default: module.RefundReasons,
  })),
);

export const RefundReasonForm = lazy(() =>
  import('./settings/refund_reasons').then((module) => ({
    default: module.RefundReasonForm,
  })),
);

export const Cash = lazy(() =>
  import('./cash').then((module) => ({
    default: module.Cash,
  })),
);

export const OperationsJournal = lazy(() =>
  import('./reports/operations').then((module) => ({
    default: module.OperationsJournal,
  })),
);

export const RecognitionRuns = lazy(() =>
  import('./reports/recognition_runs').then((module) => ({
    default: module.RecognitionRuns,
  })),
);

export const CashFlowReport = lazy(() =>
  import('./reports/cash_flow').then((module) => ({
    default: module.CashFlowReport,
  })),
);

export const ProfitAndLossReport = lazy(() =>
  import('./reports/profit_and_loss').then((module) => ({
    default: module.ProfitAndLossReport,
  })),
);

export const ProductStockBalancesReport = lazy(() =>
  import('./reports/products/stock_balances').then((module) => ({
    default: module.ProductStockBalancesReport,
  })),
);

export const ProductSalesReport = lazy(() =>
  import('./reports/products/sales').then((module) => ({
    default: module.ProductSalesReport,
  })),
);

export const ProductMovementReport = lazy(() =>
  import('./reports/products/product_movement').then((module) => ({
    default: module.ProductMovementReport,
  })),
);

export const GoodsMovementReport = lazy(() =>
  import('./reports/products/goods_movement').then((module) => ({
    default: module.GoodsMovementReport,
  })),
);

export const WarehouseTransfersReport = lazy(() =>
  import('./reports/products/transfers').then((module) => ({
    default: module.WarehouseTransfersReport,
  })),
);

export const StockCountHistoryReport = lazy(() =>
  import('./reports/products/stock_counts').then((module) => ({
    default: module.StockCountHistoryReport,
  })),
);

export const SupplyPaymentHistoryReport = lazy(() =>
  import('./reports/products/supply_payments').then((module) => ({
    default: module.SupplyPaymentHistoryReport,
  })),
);

export const SupplierSettlementsReport = lazy(() =>
  import('./reports/products/supplier_settlements').then((module) => ({
    default: module.SupplierSettlementsReport,
  })),
);

export const WarehouseSuppliers = lazy(() =>
  import('./warehouse/suppliers').then((module) => ({
    default: module.WarehouseSuppliers,
  })),
);

export const WarehouseSupplierForm = lazy(() =>
  import('./warehouse/suppliers').then((module) => ({
    default: module.WarehouseSupplierForm,
  })),
);

export const InventorySuppliers = lazy(() =>
  import('./inventory/suppliers').then((module) => ({
    default: module.InventorySuppliers,
  })),
);

export const InventorySupplierForm = lazy(() =>
  import('./inventory/suppliers').then((module) => ({
    default: module.InventorySupplierForm,
  })),
);

export const InventoryWarehouses = lazy(() =>
  import('./inventory/warehouses').then((module) => ({
    default: module.InventoryWarehouses,
  })),
);

export const Warehouses = lazy(() =>
  import('./warehouse/warehouses').then((module) => ({
    default: module.Warehouses,
  })),
);

export const WarehouseDocuments = lazy(() =>
  import('./warehouse/documents').then((module) => ({
    default: module.WarehouseDocuments,
  })),
);

export const CertificatesReport = lazy(() =>
  import('./reports/certificates').then((module) => ({
    default: module.CertificatesReport,
  })),
);

export const Salary = lazy(() =>
  import('./staff/salary').then((module) => ({
    default: module.Salary,
  })),
);

export const AuditEvents = lazy(() =>
  import('./staff/audit_events').then((module) => ({
    default: module.AuditEvents,
  })),
);
